import { useMutation } from '@tanstack/react-query';
import { Col, Row } from 'antd';
import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';

import HOPlanApi from 'apis/HOPlanApis';
import { HistoryChange } from 'assets/svg';
import { Button } from 'components';
import ButtonExport from 'components/Button/ButtonExport';
import { useTitle } from 'contexts/TitleProvider';
import path from 'routes/Path';
import TableHOPLanDetail from './TableHOPlanDetail';
import { exportExcel_v2 } from 'utils/constants/exportExcel';
import { icons } from 'utils/constants/icons';
import { IParams } from 'apis/GraphQL/Variables/hoPlan';

const { EditOutlined } = icons;

const HOPlanDetail = () => {
  const childRef = useRef<any>(null);
  const [data, setData] = useState<any>();
  const plan = useLocation().state as any;
  const { setTitle, setBreadcrumb } = useTitle();

  const { isPending: getPlantLoading, mutate: getPlantDetail } = useMutation({
    mutationFn: (year: string) => HOPlanApi.getRevenueHOPlanByYear(year),
    onSuccess: (res) => {
      const data: any[] = res.data.getRevenueHo.items;
      setData(
        data.map((item) => {
          const currentYear =
            typeof item.year === 'string' ? item.year : item.year;

          return {
            ...item,
            year: currentYear,
            typeRevenue: item.typeRevenue,
            tplant: item.tplant.name,
          };
        }),
      );
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const handleExportExcel = () => {
    const { headerRow, datas } = childRef.current.getData();
    exportExcel_v2(
      headerRow,
      datas,
      'Đăng ký kế hoạch theo chi nhánh ' + plan.year,
    );
  };

  useEffect(() => {
    setTitle(`Đăng ký kế hoạch theo chi nhánh ${Number(plan.year)}`);
    setBreadcrumb([
      { title: 'Kế hoạch' },
      { title: '[HO] Kế hoạch', href: path.HO_PLAN },
      { title: `Đăng ký kế hoạch theo chi nhánh ${Number(plan.year)}` },
    ]);
    getPlantDetail(plan.year);
  }, []);

  return (
    <>
      <Row
        gutter={[8, 16]}
        align={'middle'}
        justify={'space-between'}
        style={{ marginRight: 0 }}
      >
        <Col>
          <div className="bg-white rounded-lg shadow-md py-[2px] px-4 w-full">
            <p className="text-[#006FFD]">Trạng thái: Mới tạo</p>
          </div>
        </Col>
        <Row gutter={8}>
          <Col>
            <Button
              title="Lịch sử thay đổi"
              iconBefore={<HistoryChange />}
              handleOnclick={() => {
                console.log('object');
              }}
            />
          </Col>
          <Col>
            <ButtonExport onClick={handleExportExcel} />
          </Col>
          <Col>
            <Button
              title="Gửi duyệt"
              customClass="text-sub"
              iconBefore={<EditOutlined className="text-[14px]" />}
              handleOnclick={() => {
                console.log('object');
              }}
              fill
            />
          </Col>
        </Row>
      </Row>
      {/* <UploadModal
      importId={IMPORT}
        open={isOpenImportModal}
        setOpen={setIsOpenImportModal}
        title={'Đăng ký kế hoạch theo chi nhánh'}
        downloadTemplate={{
          fileName: 'Kế hoạch - HO Kế hoạch',
          url: URL_IMPORT_TEMPLATE_FILE.HO_PLAN_DETAIL,
        }}
      /> */}
      <TableHOPLanDetail
        ref={childRef}
        plan={plan}
        data={data}
        loading={getPlantLoading}
      />
    </>
  );
};

export default HOPlanDetail;
